import { IllustrationProps } from 'fe-design-base/assets/types';
import Box from 'fe-design-base/atoms/Box';

import binders from './imageFiles/binders.png';

const Binders = (props: IllustrationProps) => (
  <Box
    w={72}
    {...props}
    minw={72}
    className={`FDBIllustration${
      props?.className ? ` ${props.className}` : ''
    }`}
  >
    <img src={binders} style={{ width: '100%' }} alt="Binders Illustration" />
  </Box>
);
export default Binders;
